import React, { createContext, useState, useContext } from "react";
import { MESSAGE_TYPE } from "../../constants/messages";
import { useActivityLogContext } from "@thd-olt-component-react/account_activity_log";

export const CommonContext = createContext({
  alert: null,
  addAlert: () => {},
  removeAlert: () => {}
});

function CommonContextProvider(props) {
  const { children } = props;

  const [alert, setAlert] = useState(null);

  const {
    refreshData
  } = useActivityLogContext();

  const commonState = React.useMemo(() => ({
    alert,
    addAlert: (alertType, alertMessage, privacyLink=false) => {
      // when success message is shown, refresh the activity log with delay
      if(alertType === MESSAGE_TYPE.SUCCESS) {
        setTimeout(() => {
          refreshData();
        }, 1500);
      }
      setAlert({alertType, alertMessage, privacyLink});
      window.scrollTo(0, 0); // scroll to top
    },
    removeAlert: () => setAlert(null)
  }), [alert]);

  return (
    <CommonContext.Provider value={commonState}>
      {children}
    </CommonContext.Provider>
  );
}

export const useCommonContext = () => {
  const { alert, addAlert, removeAlert } = useContext(CommonContext);
  return { alert, addAlert, removeAlert };
};

export default CommonContextProvider;
